import React from "react";
import { cva } from "class-variance-authority";
import { useSettings } from "providers/settings-provider";
import { cn } from "utils/cn";

const containerVariants = cva("w-full mx-auto px-4 lg:px-6", {
  variants: {
    width: {
      fixed: "max-w-[1440px]",
      fluid: "",
    },
  },
  defaultVariants: {
    width: "fixed",
  },
});

const Container = ({ children, width, className = "" }) => {
  const { settings } = useSettings();
  const effectiveWidth = width ?? settings.container ?? "fixed";

  return (
    <div
      data-slot="container"
      className={cn(containerVariants({ width: effectiveWidth }), className)}
    >
      {children}
    </div>
  );
};

export default Container;
